module.exports = __webpack_public_path__ + "img/Check1.dee2854e.svg";